import { render, staticRenderFns } from "./iconText.vue?vue&type=template&id=d6def958&scoped=true"
import script from "./iconText.vue?vue&type=script&lang=js"
export * from "./iconText.vue?vue&type=script&lang=js"
import style0 from "./iconText.vue?vue&type=style&index=0&id=d6def958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6def958",
  null
  
)

export default component.exports